import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { toast } from 'sonner';
import { API, axios } from '../../utils/api';
import { LINGUE } from '../../utils/scheda';
import { robustezzaPassword } from '../../utils/registrazione';

// "Modifica" nella testa della scheda cliente: nome, cognome, email, telefono, lingua, città
// (PUT /clienti/{id}/anagrafica, backend/anagrafica.py). L'email la cambia l'admin o chi segue il cliente: il login
// passa alla nuova, parte un'email alla nuova casella con copia alla vecchia. Il telefono si salva con il +39.

// Solo l'admin: una nuova password per il cliente (POST /admin/clienti/{id}/reset-password), stessa regola della
// registrazione. Il cliente la usa al prossimo accesso; codici e passkey restano.
const NuovaPassword = ({ clienteId }) => {
  const [aperta, setAperta] = useState(false);
  const [password, setPassword] = useState('');
  const [attesa, setAttesa] = useState(false);
  const forza = robustezzaPassword(password);
  const salva = async () => {
    setAttesa(true);
    try {
      await axios.post(`${API}/admin/clienti/${clienteId}/reset-password`, { new_password: password });
      toast.success('Password nuova salvata: comunicatela al cliente');
      setPassword(''); setAperta(false);
    } catch (err) {
      toast.error(typeof err.response?.data?.detail === 'string' ? err.response.data.detail : 'Password non salvata');
    } finally { setAttesa(false); }
  };
  if (!aperta) return <button type="button" className="link nuova-password" onClick={() => setAperta(true)}>Imposta una nuova password…</button>;
  return (
    <div className="nuova-password" data-testid="nuova-password">
      <label htmlFor="md-password">Nuova password del cliente
        <input id="md-password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" />
        <small className={password && !forza.accettabile ? 'avviso' : undefined}>{password ? forza.testo : 'Almeno 8 caratteri, con lettere e numeri o una maiuscola.'}</small>
      </label>
      <button type="button" className="btn sm" onClick={salva} disabled={!forza.accettabile || attesa}>{attesa ? 'Salvo…' : 'Salva la password'}</button>
    </div>
  );
};

const ModificaDati = ({ cliente, puoEmail, puoPassword = false, onChiudi, onFatto }) => {
  const [dati, setDati] = useState({
    nome: cliente.nome || '', cognome: cliente.cognome || '', email: cliente.email || '', telefono: cliente.telefono || '',
    lingua: cliente.lingua || 'it', citta: cliente.citta_abita || '',
  });
  const [errore, setErrore] = useState(null);
  const [attesa, setAttesa] = useState(false);
  useEffect(() => {
    const esc = (e) => { if (e.key === 'Escape') onChiudi(); };
    document.addEventListener('keydown', esc);
    return () => document.removeEventListener('keydown', esc);
  }, [onChiudi]);
  const campo = (k) => ({ id: `md-${k}`, value: dati[k], onChange: (e) => { setDati({ ...dati, [k]: e.target.value }); setErrore(null); } });
  const emailCambia = dati.email.trim().toLowerCase() !== (cliente.email || '').toLowerCase();

  const salva = async (e) => {
    e.preventDefault();
    setAttesa(true);
    const corpo = { ...dati };
    if (!puoEmail) delete corpo.email;
    try {
      const r = await axios.put(`${API}/clienti/${cliente.id}/anagrafica`, corpo);
      if (!r.data.cambiati.length) toast('Niente da cambiare');
      else toast.success(r.data.email_cambiata ? `Salvato. Il cliente ora entra con ${r.data.cliente.email}: email inviata alla nuova e alla vecchia casella` : 'Dati salvati');
      onFatto(r.data);
    } catch (err) {
      setErrore(typeof err.response?.data?.detail === 'string' ? err.response.data.detail : 'Non salvato');
      setAttesa(false);
    }
  };

  return createPortal(
    <div className="st st-modale modifica-modale" role="presentation" onMouseDown={(e) => { if (e.target === e.currentTarget) onChiudi(); }}>
      <form className="scatola" role="dialog" aria-modal="true" aria-labelledby="md-titolo" data-testid="modifica-dati" onSubmit={salva}>
        <h3 id="md-titolo">Dati di {cliente.nome_intero || cliente.nome}</h3>
        <div className="griglia">
          <label htmlFor="md-nome">Nome<input {...campo('nome')} required maxLength={80} autoComplete="off" /></label>
          <label htmlFor="md-cognome">Cognome<input {...campo('cognome')} required maxLength={80} autoComplete="off" /></label>
          <label htmlFor="md-email" className="largo">Email (per entrare in MK Client)
            <input {...campo('email')} type="email" autoComplete="off" disabled={!puoEmail} />
            {!puoEmail && <small>La cambia l'admin o chi segue il cliente.</small>}
            {puoEmail && emailCambia && dati.email.trim() && <small className="avviso">Il cliente entrerà con la nuova email: gli scriviamo alla nuova casella, con copia alla vecchia. Password, codici e passkey restano.</small>}
          </label>
          <label htmlFor="md-telefono">Telefono<input {...campo('telefono')} inputMode="tel" autoComplete="off" placeholder="333 123 4567" />
            <small>Si salva con il +39: vale subito per WhatsApp e Chiama.</small></label>
          <label htmlFor="md-lingua">Lingua
            <select {...campo('lingua')}>{LINGUE.map(([k, n]) => <option key={k} value={k}>{n}</option>)}</select></label>
          <label htmlFor="md-citta" className="largo">Città (dove abita)<input {...campo('citta')} maxLength={80} autoComplete="off" /></label>
        </div>
        {errore && <p className="errore" role="alert">{errore}</p>}
        <p className="nota">Ogni modifica va in cronologia con chi l'ha fatta e il valore di prima.</p>
        {puoPassword && <NuovaPassword clienteId={cliente.id} />}
        <div className="bottoni">
          <button type="button" className="btn sm" onClick={onChiudi}>Annulla</button>
          <button type="submit" className="btn sm p" disabled={attesa}>{attesa ? 'Salvo…' : 'Salva'}</button>
        </div>
      </form>
    </div>,
    document.querySelector('.mk-staff') || document.body,
  );
};

export default ModificaDati;
